export default __webpack_public_path__ + "static/media/UXP_White_Logo.d49a00ac.png";